import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { Link, browserHistory } from 'react-router';

import {
    getPriceSheet,
    deletePriceSheet,
    saveEditPriceSheet
} from '../../../../redux/actions';
import GenericOverlayDialog from '../../../dialogs/genericOverlayDialog';
import PriceSheetAdminDateOverlayDialog from '../../../dialogs/priceSheetAdminDateOverlayDialog';

class PriceSheetAdmin extends Component {

    constructor(props) {
        super(props);
        this.state = {
            priceSheets: [],
            confirmationMessage:'',
            deletingPriceSheet:'',
            genericDialogHeading: '',
			genericDialogText: '',
			modalButtons: '',
            showDeleteTemplateOverlaydialog: false,
            showPriceSheetAdminDateOverlayDialog: false,
            indexOfPrcSheetToDelete:'',
            runPriceSheet:'',
            existingReports: []
        }
    }

    componentWillMount() {
        const self = this;
        self.props.getPriceSheet(`isSiteManagment=true`, true, response => {
                if(response.responseCode === 200){
                    self.setState({
                        priceSheets: JSON.parse(JSON.stringify(response.responseObject)),
                    });
                }
            });
    }

    componentDidMount() {
        const self = this;
        self.props.getPriceSheet(`isSiteManagment=false&accountNumber=`+this.props.state.user.selectedAccount.ACCOUNTNUMBER+`&salesAgreement=`+this.props.state.user.selectedPriceSource.AGREEMENT_NUMBER, true, resp => {
            self.setState({
                existingReports: Object.entries(resp.responseObject).map( ([key, value]) => ({ key, value }))
            });
        });
    }

    handleCreatePriceSheet(event) {
        event.preventDefault();
        browserHistory.push('/siteManagement/priceSheetAdmin/create');
    }
    handleEditPriceSheet(item, event) {
        event.preventDefault();
        const self = this;
        self.props.saveEditPriceSheet(item);
        browserHistory.push('/siteManagement/priceSheetAdmin/edit');
    }
    handleRunPriceSheet(item, index, event){
        // Handle Run price sheet 
        event.preventDefault();
        const self = this;
        self.setState({
            runPriceSheet: item,
        }, () => {
            self.handleDialog('PriceSheetAdminDateOverlayDialog', true, event);
        });
    }

    handleDialog(dialog, flag, event) {
		event && event.preventDefault();
		this.setState({
			['show'+dialog]: false
		}, () => {
			this.setState({
				['show'+dialog]: flag
			})
		})
	}

    showConfirmationForDelete(item, index, event) {
        event.preventDefault();
        const self = this;
        self.setState({
            deletingPriceSheet: item,
            indexOfPrcSheetToDelete: index,
            genericDialogHeading: 'CONFIRM DELETE',
            genericDialogText: 'Are you sure you want to permanently delete this template?',
            modalButtons: 'cancel,yes',
        }, () => {
            self.handleDialog('DeleteTemplateOverlaydialog', true, event);
        });
    }
    handleDeletePriceSheet(event) {
        event.preventDefault();
        const self = this;
        let {indexOfPrcSheetToDelete, deletingPriceSheet } = self.state;
        if(self.state.showDeleteTemplateOverlaydialog) {
		    self.handleDialog('DeleteTemplateOverlaydialog', false, event);
            self.setState({
            confirmationMessage: '',
            }, () => {
                self.props.deletePriceSheet(deletingPriceSheet, `priceSheet_id=${deletingPriceSheet.priceSheet_id}`, response => {
                    if (response.status) {
                        // Remove deleted message from the state
                        const updatedPriceSheets = self.state.priceSheets.filter((priceSheets, priceSheetIndex) => priceSheetIndex !== indexOfPrcSheetToDelete);
                        self.setState({
                            priceSheets: updatedPriceSheets,
                            confirmationMessage: 'Price Sheet has been successfully deleted.'
                        });
                    } else {
                        browserHistory.push('/error');
                    }
                });
            });
        } else {
            
        }
        
    }
    render() {
        const self = this;
        return (
            <div>
                <div className="push">
                    <h1 className="pageTitle">PRICE SHEET ADMINISTRATION</h1>
                </div>
                {this.state.confirmationMessage && <p className="bold red">{this.state.confirmationMessage}</p>}
                 {<table className="dataTable savedBrochuresTable savedBrochuresASMTable">
                            <thead>
                                <tr>
                                    <th>Template</th>
                                    <th>Price Effective <br/> Date</th>
                                    <th>Last Update <br/> Date</th>
                                    <th>Edit</th>
                                    <th>Delete Template</th>
                                    <th>Run Template as <br/> Admin</th>
                                </tr>
                            </thead>
                            <tbody>
                                {self.state.priceSheets && self.state.priceSheets.length >0 && self.state.priceSheets.map((item, index) => {
                                    return <tr key={index}>
                                                <td>{item.template_name}</td>
                                                <td>{item.effective_date}</td>
                                                <td>{item.last_update_date ? item.last_update_date : 'NA'}</td>
                                                {<td>
                                                    <a className="editTemplateIcon" href="" onClick={this.handleEditPriceSheet.bind(this, item)}>
                                                        <img src="../images/icon-edit-brochure-large.png" width={26} height={21} alt="Edit Template" title="Edit Template" />
                                                    </a>
                                                </td>}
                                            <td><a className="xMe" href="" onClick={this.showConfirmationForDelete.bind(this, item, index)}>X</a></td>
                                            <td className="txt-ctr">
											    <a className="blueButton" href="" onClick={this.handleRunPriceSheet.bind(this, item, index)} style={{fontSize: '0.9em'}}>Run</a>
										    </td>
                                        </tr>
                                })}
                            </tbody>
                        </table>
                    } 
                    <p className="textRight">
                        <input type="button" onClick={this.handleCreatePriceSheet.bind(this)} className="blueButton uppercase" defaultValue="CREATE TEMPLATE" />
                    </p>
                    <hr></hr>
                    {<table className="dataTable savedBrochuresTable savedBrochuresASMTable">
                        <thead>
                            <tr>
                                <th>Generated Reports</th>
                            </tr>
                        </thead>
                        <tbody>
                            {self.state.existingReports && self.state.existingReports.length > 0 && self.state.existingReports.map((report, index) => {
                                return <tr key={index}>
                                            <td>
                                                <a href={report.value} target="_blank" rel="noopener noreferrer">{report.key}</a>
                                            </td>
                                        </tr>
                            })}
                        </tbody>
                     </table>
                    }

                    <p>
                        <Link to="/siteManagement">Back to Site Management</Link>
                    </p>
                    {self.state.showDeleteTemplateOverlaydialog ? <GenericOverlayDialog flag={'DeleteTemplateOverlaydialog'} handleYes={this.handleDeletePriceSheet.bind(this)} genericDialogHeading={this.state.genericDialogHeading} genericDialogText={this.state.genericDialogText} buttons={this.state.modalButtons} handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
                    {self.state.showPriceSheetAdminDateOverlayDialog ? <PriceSheetAdminDateOverlayDialog flag={'PriceSheetAdminDateOverlayDialog'} runPriceSheet={this.state.runPriceSheet} userData = {this.props.state.user} handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {state};
};

const mapDispatchToProps = (dispatch) => ({
    getPriceSheet: (queryString, showLoader, callback) => dispatch(getPriceSheet(queryString, showLoader, callback)),
    deletePriceSheet: (payload, queryStringParams, callback) => dispatch(deletePriceSheet(payload, queryStringParams, callback)),
    saveEditPriceSheet: (data) => dispatch(saveEditPriceSheet(data)),
});

PriceSheetAdmin = connect(mapStateToProps, mapDispatchToProps)(PriceSheetAdmin);
export default PriceSheetAdmin;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/SiteManagement/PriceSheetAdmin/index.js